import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { faCalendarDays, faCircleExclamation, faEye, faFileExcel, faFilePdf, faMagnifyingGlass, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { UsageHistoryService } from 'src/app/services/usage-history.service';
import { ModalMinhasLiberacoesComponent } from 'src/app/shared/modals/modal-minhas-liberacoes/modal-minhas-liberacoes.component';
import { ServiceStatus } from 'src/app/shared/models/saude/service-status';
import { UsageHistory } from 'src/app/shared/models/saude/usage-history';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
import { FormValidator } from 'src/app/shared/validators/Validator';
import { HealthService } from '../../../services/saude/health.service';
@Component({
  selector: 'app-minhas-liberacoes',
  templateUrl: './minhas-liberacoes.component.html',
  styleUrls: ['./minhas-liberacoes.component.css']
})
export class MinhasLiberacoesComponent {
  loading: boolean = false;
  //Icones    
  faCalendarDays = faCalendarDays;
  faCircleExclamation = faCircleExclamation;
  faEye = faEye;
  faFilePdf = faFilePdf;
  faFileExcel = faFileExcel;
  faMagnifyingGlass = faMagnifyingGlass;
  faTriangleExclamation = faTriangleExclamation;
  //Listas
  beneficiaries: any[] = [];
  convenants: any[] = [];
  extratoFinanceiro: any[] = [];
  usageHistory!: any[];
  //Variaveis  
  beneficiary: any;
  cpfResponsavel: any;
  dataAtual: any;
  dataInicial: any;
  dataFinal: any;
  serviceStatus!: ServiceStatus[];
  //Objetos
  validator = new FormValidator();
  dataLimiteInicial: any;
  dataLimiteFinal: any;
  myRequestsFilter: any = { itemsPerPage: 5, page: 0 };
  //Formulários
  formGroup: FormGroup = new FormGroup({
    finalDate: new FormControl(null, [Validators.required]),
    initialDate: new FormControl(null, [Validators.required]),
    itemsPerPage: new FormControl(5),
    page: new FormControl(0),
    personCpf: new FormControl(null),
    serviceStatusId: new FormControl(null)
  });
  constructor(private userService: UsuarioService, private modalService: NgbModal, private healthService: HealthService, private usageService: UsageHistoryService, private bsLocaleService: BsLocaleService) {
    //Data
    this.dataAtual = new Date();
    //Alterando a data do calendário para pt-br
    this.bsLocaleService.use('pt-br');
    this.userService.getBeneficiaries().subscribe(
      (res: any) => {
        this.beneficiaries = res;
        this.cpfResponsavel = this.beneficiaries[0].id;
        this.formGroup.get('personCpf')?.setValue(this.beneficiaries[0].id);
      }
    );
    this.healthService.getRequestStatus().subscribe((res: any) => { this.serviceStatus = res; });
    this.consultar();
  }
  protected download(fileType: string): any {
    this.healthService.downloadFile(this.formGroup.value, 'history', fileType).subscribe({
      next: (res: any) => {
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        if (fileType == 'pdf') a.download = "Historico de Utilizações.pdf";
        else a.download = "Historico de Utilizações.xlsx";
        a.href = URL.createObjectURL(res);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
      }
    });
  };
  protected consultar(): void {
    this.loading = !this.loading;
    this.formGroup.get('page')?.setValue(1);
    let filter = this.formGroup.value;
    this.healthService.getPendingRequests(filter).subscribe({
      next: (res: any) => {
        this.usageHistory = res.filter((x: UsageHistory) => x.cpf == this.formGroup.get('personCpf')?.value);
        this.beneficiary = this.usageHistory[0];
        this.loading = !this.loading;
      },
      error: (err: any) => {
        this.loading = !this.loading;
      }
    });
  }
  protected visualizar(details: any): void {
    const modalRef = this.modalService.open(ModalMinhasLiberacoesComponent, { windowClass: 'carteirinha-modal-size', centered: true });
    modalRef.componentInstance.details = details;
  }
  onChangeQuantidadeItens(quantidade: number) {
    this.myRequestsFilter.itemsPerPage = quantidade;
    this.formGroup.get('itemsPerPage')?.setValue(this.myRequestsFilter.itemsPerPage);
    this.consultar();
  }
  protected customSearchFn($event: any): void {
    let search = $event.term
    if (typeof search === 'string' && search.length > 2) {
      this.usageService.getCovenants(search).subscribe((res: any) => {
        res.items.forEach((resp: any) => {
          resp.tradeName = resp.tradeName.trim().toUpperCase();
        })
        this.convenants = res.items;
      })
    }
  }
  protected onChangePagination(page: any) {
    this.myRequestsFilter.page = page;
    this.formGroup.get('page')?.setValue(this.myRequestsFilter.page);
    let filter = this.formGroup.value;
    filter.page = filter.page - 1;
    this.healthService.getPendingRequests(filter).subscribe({
      next: (res: any) => {
        this.usageHistory = res.filter((x: UsageHistory) => x.cpf == this.formGroup.get('personCpf')?.value);
        this.beneficiary = this.usageHistory[0];
      }
    });
  }
}
